<template>
    <el-dialog :visible.sync="dialogVisible" width="800px" height="600px" class="dialog-container">
      <template #header>
        <button class="custom-close-button" @click="dialogVisible = false">
          <i class="el-icon-close"></i>
        </button>
      </template>
      <swiper :options="dialogSwiperOptions2" ref="dialogSwiper">
        <swiper-slide v-for="(item, key) in srcList" :key="key">
          <div class="dialog-slider-image"><img :src="item"/></div>
        </swiper-slide>
      </swiper>
      <div class="dialog-navigation">
        <div class="dialog-button-prev el-icon-arrow-left" slot="button-prev"></div>
        <div class="dialog-button-next el-icon-arrow-right" slot="button-next"></div>
      </div>
    </el-dialog>
</template>

<script>
import awesomeSwiper from '../home/components/awesomeSwiper'
import {swiper, swiperSlide} from 'vue-awesome-swiper'

export default {
  name: 'img-preview',
  components: {
    awesomeSwiper,
    swiperSlide,
    swiper
  },
  props: {
    srcList: {
      default: [],
      type: Array
    }

  },
  data() {
    return {
      dialogVisible: false,
      dialogSwiperOptions2: {
        slidesPerView: 1,
        navigation: {
          nextEl: '.dialog-button-next',
          prevEl: '.dialog-button-prev'
        }
      },
      viewUrl: ''
    }
  },
  methods: {
    init(url) {
      this.dialogVisible = true
      this.viewUrl = url
      this.postionToImg()
    },
    postionToImg() {
      let index = 0
      if (this.srcList) {
        index = this.srcList.indexOf(this.viewUrl)
      }
      this.$nextTick(() => {
        this.$refs.dialogSwiper.swiper.slideTo(index, 0)
      })
    }
  },
  watch: {
    srcList: {
      handler: function (val, oldVal) {
        this.postionToImg()
      },
      deep: true
    }
  }

}
</script>

<style scoped lang="less">

.swiper-slide{
  width:20%;
}

.swiper-slide img {
  width: 100%; /* 设置图片宽度为 100% */
  object-fit: cover; /* 根据需要调整图片的填充方式 */
}

.dialog-container {
  padding: 0;
}

.dialog-content {
  position: relative;
  height:600px;
  width:800px;

}
.swiper-container{
  height: 600px !important;
}

.dialog-slider-image {
  width: 800px;
  height: 600px;
  img{
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.dialog-navigation {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  z-index: 1;
}

.dialog-button-prev,
.dialog-button-next,
.dialog-close {
  font-size: 30px;
  color: white;
  cursor: pointer;
}

.dialog-button-prev:hover,
.dialog-button-next:hover,
.dialog-close:hover {
  color: #ccc;
}

.dialog-button-prev {
  margin-right: 10px;
}

.dialog-close {
  position: absolute;
  top: 10px;
  right: 10px;
}

/deep/ .el-dialog__headerbtn {
  position: absolute;
  height: 32px;
  width:32px;
  top: 0;
  right: 0;
  padding: 0;
  background: #262B2F;
  opacity: 0.9;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 30px;
}
/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: white;
  position: relative;
  bottom: 3px;
}
/deep/ .el-dialog{
  background: black !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/vilocal/img-preview.vue